/** @format */

import React from 'react';
import { BottomDetails, Card, CardInfo, Divider } from '@/components/ui/CardRoom/index.style';
import {
  SkeletonDetailsIcon,
  SkeletonDetailsText,
  SkeletonGalleryContent,
  SkeletonTitle,
  FormattedPriceSkeleton,
  SkeletonAvailabiltyStatus,
} from './index.style';
import { BaseDetails, Wrapper } from '@/components/ui/CardRoom/Details.style';
import { NumbersWrapper, Wrapper as PriceWrapper } from '@/components/ui/CardRoom/Price.style';
import { Wrapper as AvailabilityWrapper, IconWrapper } from '@/components/ui/CardRoom/Availability.style';

interface CardRoomSkeletonProps {
  hideTopRadius?: boolean;
}

export const CardRoomSkeleton: React.FC<CardRoomSkeletonProps> = ({ hideTopRadius = false }) => {
  return (
    <Card $hideTopRadius={hideTopRadius}>
      <SkeletonGalleryContent />
      <CardInfo>
        <SkeletonTitle>&nbsp;</SkeletonTitle>
        <Wrapper>
          <BaseDetails>
            <SkeletonDetailsIcon />
            <SkeletonDetailsText>&nbsp;</SkeletonDetailsText>
          </BaseDetails>
          <BaseDetails>
            <SkeletonDetailsIcon />
            <SkeletonDetailsText>&nbsp;</SkeletonDetailsText>
          </BaseDetails>
          <BaseDetails>
            <SkeletonDetailsIcon />
            <SkeletonDetailsText>&nbsp;</SkeletonDetailsText>
          </BaseDetails>
        </Wrapper>
        <Divider />
        <BottomDetails>
          <PriceWrapper>
            <NumbersWrapper>
              <FormattedPriceSkeleton>&nbsp;</FormattedPriceSkeleton>
            </NumbersWrapper>
          </PriceWrapper>
          <AvailabilityWrapper>
            <IconWrapper>
              <SkeletonDetailsIcon />
              <SkeletonDetailsText>&nbsp;</SkeletonDetailsText>
            </IconWrapper>
            <SkeletonAvailabiltyStatus>&nbsp;</SkeletonAvailabiltyStatus>
          </AvailabilityWrapper>
        </BottomDetails>
      </CardInfo>
    </Card>
  );
};
